import './style.scss';
import { render } from '@wordpress/element';
import Users from "./Users";

const targetElement = document.getElementById('acb_admin_chat_box_users');
if (targetElement) {
    console.log('Rendering Users component');
    render(<Users />, targetElement);
} else {
    console.error('Target element acb_admin_chat_box_users not found');
}